export default {"src":"/_next/static/media/manageEntities.12d1c379.svg","height":18,"width":18};